export default "__VITE_ASSET__glQKGSD0__"